/* Packages */
import React, { useState, useEffect } from 'react';
import NumberFormat from 'react-number-format';

/* Utilities */
import { trans } from '~/utilities';

export default function RangeOpenFilter({ filter = {}, updateFilters, value, formControlClassName }) {
    /* State */
    const [newValue, setNewValue] = useState(value);

    /* Constants */
    const { name, filterKey } = filter;

    useEffect(() => {
        setNewValue(value);
    }, [value]);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (newValue?.min !== value?.min || newValue?.max !== value?.max) {
                updateFilters(newValue);
            }
        }, 500);

        return () => clearTimeout(handler);
    }, [newValue, value]);

    /* Render */
    return (
        <div className="row row--equalized gutters-2">
            <div className="col">
                <input
                    type="hidden"
                    name={filterKey}
                    value={`${newValue?.min || ''};${newValue?.max || ''}`}
                />
                <NumberFormat
                    value={newValue?.min > 0 ? newValue.min : ''}
                    displayType={'input'}
                    decimalSeparator=","
                    thousandSeparator="."
                    fixedDecimalScale={true}
                    inputMode="numeric"
                    id={`${name}-Van`}
                    className={`form-control ${formControlClassName}`}
                    placeholder={trans('app.content_block.vehicles.filter.range_open.from')}
                    decimalScale={0}
                    onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                    onValueChange={({ floatValue }) => {
                        setNewValue(prev => ({ ...prev, min: floatValue }));
                    }}
                />
            </div>
            <div className="col">
                <NumberFormat
                    value={newValue?.max > 0 ? newValue.max : ''}
                    displayType={'input'}
                    decimalSeparator=","
                    thousandSeparator="."
                    fixedDecimalScale={true}
                    inputMode="numeric"
                    id={`${name}-Tot`}
                    className={`form-control ${formControlClassName}`}
                    placeholder={trans('app.content_block.vehicles.filter.range_open.to')}
                    decimalScale={0}
                    onValueChange={({ floatValue }) => {
                        setNewValue(prev => ({ ...prev, max: floatValue }));
                    }}
                />
            </div>
        </div>
    );
}
